import { activeVersionMsg, t } from '../../../common/i18n/index.js';
import { formatDefinedTimestampToDDMMYYYY } from '../../../common/utils/dateUtils.js';
import { GutterStyle, SelectOneList } from '../../SelectOneList/index.js';
import { SubscriptionScheduledChangeDisclaimer, SubscriptionVersion } from './SubscriptionScheduledChangeDisclaimer.js';

interface SubscriptionVersionSelectorProps {
  scheduledChangeTimestamp: number;
  subscriptionVersion: SubscriptionVersion;
  onSubscriptionVersionChange: (version: SubscriptionVersion) => void;
}

const SubscriptionVersionOption = (
  label: string,
  version: SubscriptionVersion,
  currentVersion: SubscriptionVersion,
  onSelect: (v: SubscriptionVersion) => void
) => ({
  element: <div>{label}</div>,
  isSelected: currentVersion === version,
  onClick: () => onSelect(version),
});

export const SubscriptionVersionSelector = ({
  scheduledChangeTimestamp,
  subscriptionVersion,
  onSubscriptionVersionChange,
}: SubscriptionVersionSelectorProps) => (
  <div className="of-billing-account-scheduled-change">
    <SelectOneList
      disableIcon
      gutterStyle={GutterStyle.Minimal}
      maxItemsAsideDesktop={2}
      fullWidth={false}
      options={[
        SubscriptionVersionOption(
          t.F6OD(activeVersionMsg),
          SubscriptionVersion.ACTIVE,
          subscriptionVersion,
          onSubscriptionVersionChange
        ),
        SubscriptionVersionOption(
          `${t.N4LE('Scheduled changes')} ${formatDefinedTimestampToDDMMYYYY(scheduledChangeTimestamp)}`,
          SubscriptionVersion.SCHEDULED,
          subscriptionVersion,
          onSubscriptionVersionChange
        ),
      ]}
    />
    <SubscriptionScheduledChangeDisclaimer
      scheduledChangeTimestamp={scheduledChangeTimestamp}
      subscriptionVersion={subscriptionVersion}
    />
  </div>
);
